import SearchInput from './SearchInput';

import { gql, graphql } from 'react-apollo';

const CATEGORY_SEARCH_QUERY = gql`
  query searchCategories(
    $filter: CategoryFilter
    $orderBy: CategoryOrderBy
    $first: Int
  ) {
    allCategories(filter: $filter, orderBy: $orderBy, first: $first) {
      id
      label
      slug
    }
  }
`;

const searchCategoryGraphql = graphql(CATEGORY_SEARCH_QUERY, {
  options: {
    variables: {
      filter: {
        OR: [
          {
            label_contains: null,
          },
        ],
      },
      orderBy: 'label_ASC',
      first: 5,
    },
  },
  props: ({ ownProps, data }) => {
    return {
      onSearch: async label => {
        if (label && label.length > 2) {
          data.refetch({
            filter: {
              OR: [
                {
                  label_contains: label,
                },
              ],
            },
            orderBy: 'label_ASC',
            first: 5,
          });
        }

        return data.allCategories;
      },
      dataSource: data.allCategories,
      dataLoading: data.loading,
    };
  },
});

export default searchCategoryGraphql(SearchInput);



// WEBPACK FOOTER //
// ./src/common/components/CategorySearchInput.js